import React, { useContext } from 'react'
import { AppGridLayoutDesigerContext } from './AppGridLayoutDesigerContext'
import { Icon, message } from 'antd'
import api from 'api/index'
import AppMessage from 'components/AppMessage'

export const AppGridLayoutHeardDesiger = () => {
	return (
		<div className="app-grid-layout-heard-desiger">
			<Breadcrumbs />
			<Views />
			<Actions />
		</div>
	)
}

const Breadcrumbs = () => {
	return <div className="app-grid-layout-heard-item"></div>
}

const Views = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	const views = [
		{ name: '数据来源', icon: 'qcciconfont-data' },
		{ name: '列表设计', icon: 'qcciconfont-navicon-dphf' },
	]
	return (
		<div className="app-grid-layout-heard-item">
			<div className="app-grid-layout-heard-item-views">
				{views.map((view: any) => {
					return (
						<div
							key={view.name}
							onClick={e => context.chgView(view.name)}
							className={`app-grid-layout-heard-item-view ${context.view === view.name ? 'active' : ''}`}
						>
							<div className="app-grid-layout-heard-item-view-icon">
								{view.icon !== '' ? <i className={view.icon}></i> : ''}
							</div>
							<div className="app-grid-layout-heard-item-view-label">{view.name}</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

const Actions = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	const save = async () => {
		let res = await api.modeling.appgrid.save(context.metadataGird)
		if (res) {
			message.success('保存成功！')
			if (!context.metadataGird.id) {
				window.location.href = window.location.href + `&id=${res.id}`
			} else {
				window.location.href = window.location.href
			}
		} else {
			message.error('保存失败！')
		}
	}
	const preview = () => {
		if (!context.metadataGird.id) {
			message.warn('请先保存！')
			return
		}
		// window.open(`/appGrid/${context.metadataGird.id}?application=${context.metadataGird.application}`)
		window.open(`/std/${context.metadataGird.application}/appGrid/${context.metadataGird.id}`)
	}
	return (
		<div className="app-grid-layout-heard-item">
			<div className="app-grid-layout-heard-actions">
				<button className="app-grid-layout-heard-actions-item" onClick={preview}>
					<Icon type="eye" className="app-grid-layout-heard-icon-preview"></Icon>预览
				</button>
				<button className="app-grid-layout-heard-actions-item" onClick={save}>
					<Icon type="save" className="app-grid-layout-heard-icon-save"></Icon>保存
				</button>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/AppGridLayoutHeardDesiger.tsx